import { render, staticRenderFns } from "./GreetingMentionMenu.vue?vue&type=template&id=0aafd06a"
import script from "./GreetingMentionMenu.vue?vue&type=script&lang=ts"
export * from "./GreetingMentionMenu.vue?vue&type=script&lang=ts"
import style0 from "./GreetingMentionMenu.vue?vue&type=style&index=0&id=0aafd06a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports